<template>
    <div id="tagsMgmtBox">        
        <div class="searchWrap">
            <div class="row1">
                <div class="itemWrap">
                    <!-- <el-radio-group v-if="btnTagVisible" v-model="queryType" style="margin-right: 15px;" aria-label="標籤類型選擇">                        
                        <el-radio label="hq" :aria-label="'總行標籤'">總行標籤</el-radio>
                        <el-radio label="st" :aria-label="'標準標籤'">標準標籤</el-radio>
                        <el-radio label="br" :aria-label="'自訂標籤'">自訂標籤</el-radio>
                    </el-radio-group>                     -->
                    <label>公司名稱: </label>
                    <el-input v-model="keyword" placeholder="公司名稱 / 統一編號" style="width:250px;margin: 0 1rem 0 1rem;" clearable></el-input>                    
                    <el-button style="margin-right: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>                    
                </div>
            </div>          
            <div class="row3"  >
                <el-button v-if="btnHotTagVisible" type="success" @click="showHotTag=true" icon="el-icon-star-on">熱門標籤</el-button>
                <el-button type="danger" @click="addTag" icon="el-icon-plus">新增標籤</el-button> 
                <el-button v-if="btnUploadTagVisible" type="primary" @click="uploadTags" icon="el-icon-upload">上傳標籤</el-button> 
            </div>                        
        </div>
        <div class="content" style="margin-top:20px;">
            <el-tabs v-model="tabsValue" tab-position="top" type="border-card" stretch>
                <el-tab-pane label="公司搜尋" name="main">
                    <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableDataMain" @select="handleSelectionChange">              
                        <el-table-column label="統一編號"  prop="UniComNm" min-width="20%">
                                <template slot-scope="scope">   
                                    <el-tooltip content="將開啟新頁" placement="top">                               
                                    <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                                    </el-tooltip>
                                </template>
                        </el-table-column>
                        <el-table-column label="公司名稱"  prop="ComName" >
                                <template slot-scope="scope">                       
                                    <el-tooltip content="將開啟新頁" placement="top">
                                    <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>           
                                    </el-tooltip>
                                </template>
                        </el-table-column>
                        <el-table-column label="企業資訊" min-width="30%">
                            <template slot-scope="scope">                                
                                <el-button v-if="btnTagVisible && scope.row.has_hq_category" type="text" @click="showTag('hq',scope.row)" icon="el-icon-edit">總行標籤</el-button>
                                <el-button v-if="btnTagVisible" type="text" @click="showTag('st',scope.row)" icon="el-icon-edit">標準標籤</el-button>   
                                <el-button v-if="btnTagVisible && scope.row.has_br_category" type="text" @click="showTag('br',scope.row)" icon="el-icon-edit">自訂標籤</el-button>   
                            </template>
                        </el-table-column>                            
                    </el-table>
                    <Pagination
                        @currentChange="pageChange"
                        :maxPageLimit="50"
                        :pageSize="this.listQuery.Page_Size"
                        :propsCurrentPage="this.listQuery.Page_Num"
                        :totalLists="totalListsMain">
                    </Pagination>                    
                </el-tab-pane>
                <el-tab-pane label="標籤" name="detail">                    
                    <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">              
                    <el-table-column label="統一編號"  prop="UniComNm" min-width="10%">
                            <template slot-scope="scope">   
                                <el-tooltip content="將開啟新頁" placement="top">                                 
                                <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                                </el-tooltip>
                            </template>                   
                    </el-table-column>                                              
                    <el-table-column label="客戶名稱"  prop="ComName" min-width="20%">
                            <template slot-scope="scope">                       
                                <el-tooltip content="將開啟新頁" placement="top">
                                <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>           
                                </el-tooltip>
                            </template>                
                    </el-table-column>                              
                    <el-table-column label="標籤名稱" prop="name"  min-width="10%">                
                    </el-table-column>              
                    <el-table-column label="分行名稱"  prop="create_dept_name" min-width="10%">                
                    </el-table-column>  
                    <el-table-column label="建立人"  prop="create_user_name" min-width="10%"  >
                    </el-table-column>                        
                    <el-table-column label="建立時間" prop="created_date" min-width="10%">  
                    </el-table-column>
                    <el-table-column label="最後修改" prop="updated_date" min-width="10%" >  
                    </el-table-column>                         
                    <el-table-column label="企業資訊" min-width="10%">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" @click="addTag(scope.row)"><i class="el-icon-plus"></i></el-button> -->
                            <el-button type="text" @click="editTag(scope.row)" icon="el-icon-edit" :disabled="!btnTagEditable">編輯</el-button>
                            <el-button type="text" @click="delTag(scope.row)" icon="el-icon-delete" :disabled="!btnTagEditable">刪除</el-button>   
                        </template>
                    </el-table-column>                                 
                    </el-table>  
                    <Pagination
                        @currentChange="pageChange"
                        :maxPageLimit="50"
                        :pageSize="this.listQuery.Page_Size"
                        :propsCurrentPage="this.listQuery.Page_Num"
                        :totalLists="totalLists">
                    </Pagination>                                  
                </el-tab-pane>                
            </el-tabs>

        </div>
        <div class="pageBox">

        </div>          
        <!-- <div class="buttonBox">            
            <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </div>    -->
        <el-dialog title="上傳標籤" :visible.sync="showuploadTags" width="70%" center>
            <div class="dialogBox" >
                <div class="row1">
                    <div class="itemBox">
                        <label>上傳檔案：</label> 
                        <div style="display: flex; flex-direction: row; align-items: center;">
                            <input
                              type="file"
                              @change="handleFileChange"
                                accept=".xlsx"
                              ref="fileInput"
                              style="display:none"
                            />
                            <el-button size="small" type="primary" icon="el-icon-upload" @click="triggerFileInput">選擇檔案</el-button>
                            <span v-if="selectedFile" style="margin-left: 10px;">
                              已選擇: {{ selectedFile.name }}
                            </span>
                            <a href="/tbbtags.xlsx" download="tbbtags.xlsx" style="margin-left: 10px;">下載範例檔案</a>
                        </div>
                    </div>          
                </div>      
                <div class="row1" style="margin: -10px 0px 15px 90px;font-size: smaller;color:green"> 
                        格式: 項次, 統編(*), 公司名, 標籤 (*) 
                </div>                
                
                <!-- 預覽上傳的資料 -->
                <div class="row1 full-width" v-if="parsedData.length > 0">
                    <div class="preview-column">
                        <h4>檔案預覽 (前 5 筆資料):</h4>
                    </div>
                </div>
                <div class="row1 full-width" v-if="parsedData.length > 0">
                    <div class="preview-column">
                        <el-table :data="parsedData.slice(0, 5)" border style="width: 100%">
                            <el-table-column prop="項次" label="項次" ></el-table-column>
                            <el-table-column prop="統編(*)" label="統編" ></el-table-column>
                            <el-table-column prop="公司名" label="公司名" ></el-table-column>
                            <el-table-column prop="標籤(*)" label="標籤"></el-table-column>
                            <el-table-column prop="error" label="錯誤" min-width="220"></el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="row1 full-width" v-if="parsedData.length > 0">
                    <div class="preview-column">
                        <div style="margin-top: 5px; margin-bottom: 10px; color: #606266; font-size: 14px;">
                            共 {{ parsedData.length }} 筆資料
                        </div>
                    </div>
                </div>
         
                <!-- 加入潛在客戶的原因 -->
                <!-- <div style="margin: 5px 5px;">
                    <label>備註：</label>
                    <el-input type="textarea" rows="2" v-model="addInfo.memo"  placeholder="簡明描述備註" style="width:100%;margin-right:15px;margin-top:15px" clearable></el-input>                    
                </div>                 -->
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="submitData" :disabled="parsedData.length === 0" :loading="submitting" icon="el-icon-plus">送出資料</el-button>
                    <el-button type="danger" @click="resetUploadForm" icon="el-icon-close">重置</el-button>
                    <el-button @click="showuploadTags=false" icon="el-icon-close">關閉</el-button>
            </span>
        </el-dialog>      

        <el-dialog title="資料檢核錯誤" :visible.sync="errorDialogVisible" width="50%" center>
            <div style="max-height: 400px; overflow-y: auto;">
                <div style="margin-bottom: 10px; color: #E6A23C; font-weight: bold;">
                    共發現 {{ validationErrors.length }} 個錯誤：
                </div>
                <el-table :data="validationErrors" border stripe style="width: 100%;">
                    <el-table-column prop="row" label="列數" width="120"></el-table-column>
                    <el-table-column prop="error" label="錯誤訊息"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="errorDialogVisible = false">確定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="新增自訂標籤" :visible.sync="showAddTag" width="30%" center>
            <div class="dialogBox" >
                <div class="row1">
                    <div class="form-item" >
                        <label>客戶統編</label> 
                        <el-input v-model="addInfo.UniComNm" style="width:80%" placeholder="請輸入統編" ></el-input>                    
                    </div>
                </div>  
                <div class="row1" v-if="btnTypeVisible">
                    <div class="form-item">
                        <label>標籤類型</label>
                        <el-radio-group v-model="addInfo.Type" style="display: inline-flex; gap: 10px;">
                            <el-radio label="hq">總行標籤</el-radio>
                            <el-radio label="br">自訂標籤</el-radio>
                        </el-radio-group>                        
                    </div>
                </div>    
                <div class="row1" > 
                    <div class="form-item">
                        <label>標籤內容(可輸入多個標籤用逗號, 隔開)</label>
                        <el-input v-model="addInfo.tagName" style="width:80%" placeholder="請輸入標籤內容"></el-input>
                    </div>                    
                </div>                
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="addTags()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />新增</el-button>
                    <el-button type="danger"  @click="showAddTag=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog> 

        <el-dialog title="編輯自訂標籤" :visible.sync="showEditTag" width="50%" center>
            <div class="dialogBox" > 
                <div class="row1" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>標籤名稱：</label> 
                        <el-input v-model="addInfo.tagName" style="width:50%" placeholder="請輸入標籤名稱" ></el-input>                        
                    </div>
                </div>
                <div class="row1" v-if="queryType=='st'" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>標籤日期：</label> 
                        <el-input v-model="addInfo.event_date" style="width:50%" placeholder="請輸入標籤發生日期" ></el-input>                        
                        <span style="margin-left: 10px; color: #606266;">格式: YYYY-MM-DD , 可不填</span>
                    </div>
                </div>                
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="updateTag()" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />儲存</el-button>                   
                    <el-button type="danger"  @click="showEditTag=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>      

        <el-dialog title="熱門標籤" :visible.sync="showHotTag" width="50%" center>
            <div class="dialogBox" >
                <div class="row1">
                    <div class="itemBox">
                        <el-switch
                        v-model="enabledHotTag"
                        active-text="啟動標籤"
                        inactive-text="不啟動"
                        active-value="啟動標籤"
                        inactive-value="不啟動">
                        
                        </el-switch>
                    </div>
                </div>      
                <div class="row1" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag1：</label> 
                        <el-input v-if="hotTagsList[0]" v-model="hotTagsList[0].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag6：</label> 
                        <el-input v-if="hotTagsList[5]" v-model="hotTagsList[5].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>                    
                </div>
                <div class="row1" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag2：</label> 
                        <el-input v-if="hotTagsList[1]" v-model="hotTagsList[1].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag7：</label> 
                        <el-input v-if="hotTagsList[6]" v-model="hotTagsList[6].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>                    
                </div>
                <div class="row1" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag3：</label> 
                        <el-input v-if="hotTagsList[2]" v-model="hotTagsList[2].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag8：</label> 
                        <el-input v-if="hotTagsList[7]" v-model="hotTagsList[7].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>                    
                </div>
                <div class="row1" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag4：</label> 
                        <el-input v-if="hotTagsList[3]" v-model="hotTagsList[3].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag9：</label> 
                        <el-input v-if="hotTagsList[8]" v-model="hotTagsList[8].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>                    
                </div>
                <div class="row1" > 
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag5：</label> 
                        <el-input v-if="hotTagsList[4]" v-model="hotTagsList[4].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>
                    <div class="itemBox" style="width: 100%;">   
                        <label>Tag10：</label> 
                        <el-input v-if="hotTagsList[9]" v-model="hotTagsList[9].TagName" placeholder="標籤名稱" ></el-input>                        
                    </div>                    
                </div>                                                

            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary"  @click="updateHotTags" ><font-awesome-icon icon="plus"  style="margin-right:5px;" />儲存</el-button>
                    <el-button type="danger"  @click="showHotTag=false" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
            </span>
        </el-dialog>      

    </div>

    
</template>

<script>
import { notify, handleError } from '@/utils/notify';
import { set } from 'nprogress';
import { del } from 'vue';
import ExcelJS from 'exceljs';

export default {
    components: {},
    data() {
        return {

            tabsValue: 'main', // main - 公司搜尋, detail - 標籤管理
            btnHotTagVisible: false, // 熱門標籤按鈕顯示控制
            btnUploadTagVisible: false, // 上傳標籤按鈕顯示控制

            btnTagVisible: false, // 標準/總行 標籤按鈕顯示控制                        
            
            btnTagEditable: false, // 標準/總行 標籤按鈕可編輯控制

            btnTypeVisible: false, // 新增標籤類型選擇按鈕顯示控制

            queryType: 'br', // 查詢類型 br: 自訂標籤, st: 標準標籤, hq: 總行標籤

            tableData: [],
            tableDataMain: [],
            enabledHotTag: "", // 熱門標籤啟動控制
      
            showuploadTags: false,
            showEditTag: false,
            showAddTag: false,
            showHotTag: false,
            
            // Excel 上傳相關
            selectedFile: null,
            parsedData: [],
            submitting: false,
            errorDialogVisible: false,
            validationErrors: [],

            totalLists:0,
            totalListsMain:0,
            keyword: "",  
            hotTagsList: [],
            pendingDeleteTagKeys: {},
            // csvUrl: require('@/assets/tagsAssign.csv'),

            listQuery: {
                searchContent:"",
                type: "2",
                Page_Size:10,
                Page_Num:1
            },   
            uploadFileName: '',
            addInfo: {
                "UniComNm": "00433001",
                "Type": "br",
                "tagName": "二類電信 / 中小專案",    
                "event_date": "",           
            },
            tagsList: [                
                { uniComNm: "97176270", cxName: "台灣大哥大",tagName: "電信專案", Branch: "竹北分行", BranchID: 'TBB0135', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-4"},
                { uniComNm: "12345676", cxName: "地標網通", tagName: "電信專案 / 中小專案",  Branch: "基隆分行", BranchID: 'TBB0134',  Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-4"},
                { uniComNm: "12345676", cxName: "中華電信",tagName: "電信專案", Branch: "中和分行", BranchID: 'TBB0136', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-11"},
                { uniComNm: "12345676", cxName: "台灣之星",tagName: "電信專案", Branch: "基隆分行", BranchID: 'TBB0137', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-1"},
                { uniComNm: "12345676", cxName: "遠傳電信",tagName: "電信專案", Branch: "台北分行", BranchID: 'TBB0138', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-5"},
                { uniComNm: "12345676", cxName: "在地電信",tagName: "電信專案 / 中小專案", Branch: "內湖分行", BranchID: 'TBB0139', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-6"},
                { uniComNm: "12345676", cxName: "亞太電信",tagName: "電信專案", Branch: "內湖分行", BranchID: 'TBB0140', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-7"},
                { uniComNm: "12345676", cxName: "二哥大", tagName: "電信專案 / 二類電信專案", Branch: "景美分行", BranchID: 'TBB0141', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-5"},
                { uniComNm: "12345676", cxName: "無框行動", tagName: "電信專案", Branch: "桃園分行", BranchID: 'TBB0142', Creator: "Derrick", CreateDt: "2024-10-03", LastDt: "2024-10-4"}                
            ]

        }        

        
    },
    computed: {
        hasUploadErrors() {
            return this.parsedData.some(item => item && item.error);
        }
    },
    methods: {

        async showTag(queryType, row) {
            console.log('showTag', queryType, row);
            this.queryType = queryType;
            this.addInfo.UniComNm = row.UniComNm;
            await this.getDetail(row.UniComNm);
            this.tabsValue = 'detail';

        },

        getFunctions() {

            const funs = this.$store.getters.userInfo;
            const roleName = this.$store.getters.userRole;
            const DeptID = this.$store.getters.deptID;
            // console.log('roleName:', roleName);
            if( this.queryType=="br") {
                // 自訂標籤, 所有人員皆可使用
                this.btnTagVisible = true;                
                this.btnTagEditable = true;            
            }
            if( this.queryType=="hq") {
                if (roleName === 'HD' || roleName === 'HC' || roleName === 'UC' || roleName === 'HE' || roleName === 'HC1' || roleName === 'UAO') {                                    
                    this.btnTagVisible = true;                
                    this.btnTagVisible = true;
                    // 確保 DeptID 為字串再使用 startsWith，避免後端或 store 回傳 number/object 導致例外
                    const deptId = funs && funs.DeptID != null ? String(funs.DeptID) : '';
                    if (deptId.startsWith && deptId.startsWith("H77")) {
                        this.btnTagEditable = true;
                    } else {
                        // 非企金人員, 只能看不能編輯
                        this.btnTagEditable = false;
                    }
                    console.log('總行標籤權限設定 - roleName:', roleName, 'btnTagEditable:', this.btnTagEditable);
                }
            }

            if( this.queryType=="st") {
                this.btnTagEditable = false;
                console.log('標準標籤權限判斷 - roleName:', roleName, 'DeptID:', DeptID);
                if (roleName === 'HD' || roleName === 'HC' ) {                                    
                    this.btnTagVisible = true;                                    
                    // 確保 DeptID 為字串再使用 startsWith，避免後端或 store 回傳 number/object 導致例外
                    const deptId = funs && funs.DeptID != null ? String(funs.DeptID) : '';
                    if (deptId.startsWith && deptId.startsWith("H77")) {
                        this.btnTagEditable = true;
                    } else {
                        // 非企金人員, 只能看不能編輯
                        this.btnTagEditable = false;
                    }
                    console.log('標準標籤權限設定 - roleName:', roleName, 'btnTagEditable:', this.btnTagEditable);
                }                
             }

            // console.log("使用者功能列表", funs);
            if(funs && funs.Menu){
                // 控制熱門標籤按鈕顯示
                const actionsHot = funs.Menu.find(item=>item.Name=="企業標籤管理").Action || [];
                this.btnHotTagVisible = actionsHot.some(item => item.Action === "編輯熱門標籤");
                // 控制標準標籤按鈕顯示及可編輯
            }
            else {
                notify({
                    title: "錯誤",
                    message: "無法取得使用者功能列表，請重新登入",
                    type: "error"
                });
            }

            // 只有HD, HC的角色, 可以上傳標籤, 熱門標籤
            if (roleName === 'HD' || roleName === 'HC' ) {                
                this.btnUploadTagVisible = true;
                this.btnHotTagVisible = true;
                this.btnTypeVisible = true;
            }
            else {
                this.btnUploadTagVisible = false;
                this.btnHotTagVisible = false;
                this.btnTypeVisible = false;
            }

            // 國際部deptID: 041 , H07 業發部 不可使用熱門標籤功能
            if( DeptID=='041'|| DeptID=='H07' ) {
                this.btnHotTagVisible = false;
                this.btnUploadTagVisible = false;
                this.btnTypeVisible = false;
            }
        },

        async updateTag() {
            const qry = {
                "UniComNm": this.addInfo.UniComNm,
                "TagId": this.addInfo.tag_id,
                "NewTagValue": this.addInfo.tagName                
            }

            try {
                // 根據標籤類型呼叫不同的刪除API
                let response={};                
                if( this.queryType=="hq" ) {
                    response = await this.$api.apitags.update_hq_category_tag(qry);
                }
                if( this.queryType=="st" ) {
                    if( this.addInfo.event_date  ) {
                        qry.EventDate = this.addInfo.event_date; 
                    }
                    response = await this.$api.apitags.update_standard_tags(qry);
                }
                if( this.queryType=="br" ) {
                    response = await this.$api.apitags.update_category_tags(qry);
                }
                if (response && response.message=="標籤更新成功") {
                    notify({ type: 'success', title: '成功', message: `已成功更新公司 ${this.addInfo.UniComNm} 標籤為: ${this.addInfo.tagName}` });
                }
                this.showEditTag = false;
                setTimeout(() => {
                    this.getDetail(this.addInfo.UniComNm); // 更新後重新載入標籤列表
                }, 1000);
            } catch (error) {
                handleError(error, '更新自訂標籤失敗');
            }
        },

        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名

            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },

        doshowDetail(row) {
            console.log(row);

            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            // 開新頁面, 轉到ctmMapCx.vue頁面
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },                

        async addTags() {
            if (!this.addInfo.UniComNm.trim()) {
                notify({ title: '警告', message: '請輸入統一編號', type: 'warning' });
                return;
            }

            // 檢核是否為8位數字
            const uniComNmPattern = /^\d{8}$/;
            if (!uniComNmPattern.test(this.addInfo.UniComNm.trim())) {
                notify({ title: '警告', message: '統一編號格式錯誤，請輸入8位數字', type: 'warning' });
                return;
            }
            
            if (!this.addInfo.tagName.trim()) {
                notify({ title: '警告', message: '請輸入標籤名稱', type: 'warning' });
                this.showAddTag = false;
                return;
            }
            
            // 若newTagForm.content中有多個標籤，以,分隔，組成陣列
            const tagArray = this.addInfo.tagName.split(',').map(tag => tag.trim()).filter(tag => tag !== '');

            const params = {
                "UniComNm": this.addInfo.UniComNm,
                "TagValues": tagArray
            };
            console.log('新增標籤參數:', params);

            try {
                // 加上轉loadings 
                this.$store.dispatch("loadingHandler", true);
        
                
                if (this.addInfo.Type == "br") {
                    const response = await this.$api.apitags.add_category_tag(params);
                    console.log('新增標籤成功:', response);
                    if (response && response.message == "標籤新增成功 ") {
                        notify({ type: 'success', title: '成功', message: `已成功新增自訂標籤: ${this.addInfo.tagName.trim()}` });
                    } else {
                        notify({ type: 'warning', title: '提醒', message: `新增自訂標籤回應: ${response.message}` });
                    }
                } else {
                    const response = await this.$api.apitags.add_hq_category_tag(params);
                    console.log('新增標籤成功:', response);
                    tagArray.forEach(tag => {
                        this.$queryRecord(this, tag, 'tag');  // 記錄加入的標籤
                    });
                    notify({ type: 'success', title: '成功', message: `已成功新增總行標籤: ${this.addInfo.tagName.trim()}` });
                }

                this.showAddTag = false;
                // 由於後端處理可能需要時間，新增成功後等5秒再刷新資料，確保後端已經更新完成
                await new Promise(resolve => setTimeout(resolve, 3500));
                await this.getDetail(this.addInfo.UniComNm);
                await this.getList();
                           

            } catch (error) {
                handleError(error, this.addInfo.Type == "br" ? '新增自訂標籤失敗' : '新增總行標籤失敗');
            }
            finally {
                this.$store.dispatch("loadingHandler", false);
            }

        },

        async delTag(row) {
            console.log(row);
            try {
                await this.$confirm(`確定要刪除公司 ${row.ComName} 的標籤 ${row.name} 嗎？`, '警告', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });
            } catch (e) {
                // 取消刪除
                return;
            }

            const qry = {
                "UniComNm": row.UniComNm,
                "TagIds": [row.tag_id]
            };
            console.log('刪除標籤參數:', qry);

            const deleteKey = `${row.UniComNm}_${row.tag_id}`;
            this.$set(this.pendingDeleteTagKeys, deleteKey, true);

            // 樂觀更新：立即從本地列表移除
            const indexToRemove = this.tableData.findIndex(item =>
                String(item.UniComNm) === String(row.UniComNm) && String(item.tag_id) === String(row.tag_id)
            );
            if (indexToRemove > -1) {
                // 使用 Vue.delete 確保響應式更新
                this.$delete(this.tableData, indexToRemove);
                this.totalLists = Math.max(0, this.totalLists - 1);
            }

            try {
                // 根據標籤類型呼叫不同的刪除API
                let response={};
                if( this.queryType=="hq") {
                    response = await this.$api.apitags.delete_hq_category_tag(qry);
                }
                if( this.queryType=="br") {
                    response = await this.$api.apitags.delete_category_tag(qry);
                }
                if( this.queryType=="st") {
                    response = await this.$api.apitags.delete_standard_tag(qry);
                }
                console.log('刪除標籤成功:', response);

                const refreshed = await this.getDetail(row.UniComNm);
                if (refreshed) {
                    notify({ type: 'success', title: '成功', message: `已成功刪除標籤: ${row.name}` });
                } else {
                    notify({
                        type: 'warning',
                        title: '提醒',
                        message: `標籤已刪除，但列表更新失敗，請重新整理確認` 
                    });
                }
            } catch (error) {
                handleError(error, '刪除自訂標籤失敗');
                this.$delete(this.pendingDeleteTagKeys, deleteKey);
                // 失敗時重新抓資料，避免畫面和後端不同步
                await this.getDetail(row.UniComNm);
            }
        },

        updateHotTags() {
            let qry = [];
            this.hotTagsList.forEach((tag, index) => {
                const item = {
                    "ID": tag.ID,
                    "TagName": tag.TagName,
                    "SortOrder": tag.SortOrder
                };                
                qry.push(item);
            });
            console.log("更新熱門標籤參數:", this.enabledHotTag);
            // 新增第11個Tag, 用來控制熱門標籤功能啟動與否
            if( this.enabledHotTag=="啟動標籤") {
                qry.push({
                    "ID": 11,
                    "TagName": "Y",
                    "SortOrder": 11
                });
            }else {
                qry.push({
                    "ID": 11,
                    "TagName": "N",
                    "SortOrder": 11
                });
            }

            this.$api.apihottags.updateHotTags({ Tags: qry }).then((res)=>{
                console.log('更新熱門標籤成功:', res);
                notify({ title: '成功', message: '熱門標籤更新成功', type: 'success' });                
                this.showHotTag = false;
            }, err => {
                handleError(err, '更新熱門標籤失敗');
            });

        },

        loadHotTags() {

            console.log("loadHotTags");
            const qry = {isSys:true};
            this.$api.apihottags.getAllHotTags(qry).then((res)=>{
                console.log('取得熱門標籤成功:', res);
                this.hotTagsList = res.data;
                // 新增Weight屬性, 利用SortOrder來決定字體大小, 第1名最大, 依序遞減
                // 利用LN函數來平滑字體大小差異
                const maxWeight = 20; // 最大字體大小
                // 取出第11名顯示狀態的Tag, 用來控制熱門標籤功能啟動與否
                this.enabledHotTag = this.hotTagsList.find(tag => tag.ID === 11 && tag.TagName === "Y") ? "啟動標籤" : "不啟動";

                this.hotTagsList = this.hotTagsList.slice(0, 10); // 只取前10名
                this.hotTagsList.forEach((tag, index) => {
                    //tag.Weight = maxWeight - index; // 根據排序順序設定 Weight
                    tag.Weight = Math.max(1, Math.round(Math.log(maxWeight - index + 1) )); // 使用對數函數平滑字體大小
                });
                console.log('熱門標籤列表:', this.hotTagsList);
            }, err => {
                handleError(err, '取得熱門標籤失敗');
            });
        },        



        editTag(row) {
            console.log(row);
            this.addInfo = {
                "UniComNm": row.UniComNm,
                "tag_id": row.tag_id,
                "tagName": row.name,
                "event_date": row.event_date || "",
            };
            this.showEditTag = true;
        },
        addTag(row) {
            console.log(row);
            this.addInfo = {
                "UniComNm": "",
                "tagName": "",
                "Type": "br",
            };
            this.showAddTag = true;
        },        



        uploadTags() {
            this.showuploadTags = true;
        },

        // 觸發檔案選擇
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        
        // 處理選擇的檔案
        handleFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            // 檢查檔案類型
            const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                /\.xlsx$/i.test(file.name || '');
            
            if (!isExcel) {
                this.$message.error('只能上傳 .xlsx 檔案!');
                return;
            }
            
            if (file.size > 10 * 1024 * 1024) {
                this.$message.error('檔案大小不能超過 10MB!');
                return;
            }
            this.uploadFileName = file.name;
            this.selectedFile = file;
            this.parseExcel(file);
        },
        
        // 解析 Excel 檔案
        parseExcel(file) {
            const reader = new FileReader();
            
            reader.onload = async (e) => {
                try {
                    const cellValueToPlain = (value) => {
                        if (value === null || value === undefined) return '';
                        if (typeof value !== 'object') return value;
                        if (Array.isArray(value.richText)) {
                            return value.richText.map(part => part && part.text ? part.text : '').join('');
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'text')) {
                            return value.text || '';
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'result')) {
                            return cellValueToPlain(value.result);
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'hyperlink')) {
                            return value.text || value.hyperlink || '';
                        }
                        if (Object.prototype.hasOwnProperty.call(value, 'formula')) {
                            return cellValueToPlain(value.result);
                        }
                        return String(value);
                    };

                    const data = e.target.result;
                    const workbook = new ExcelJS.Workbook();
                    await workbook.xlsx.load(data);

                    const worksheet = workbook.worksheets[0];
                    if (!worksheet) {
                        this.$message.error('Excel 檔案沒有工作表');
                        return;
                    }

                    // 保留既有 header 指定邏輯（固定欄位映射）
                    const headers = ['項次', '統編(*)', '公司名', '標籤(*)'];
                    const rows = [];
                    worksheet.eachRow({ includeEmpty: false }, row => {
                        rows.push(row.values.slice(1));
                    });

                    const jsonData = rows.map(row => {
                        const item = {};
                        headers.forEach((header, idx) => {
                            item[header] = cellValueToPlain(row[idx]);
                        });
                        return item;
                    });
                    
                    // 如果第一行是標題，則刪除
                    if (jsonData.length > 0 && typeof jsonData[0]['統編(*)'] === 'string' &&
                        (jsonData[0]['統編(*)'].includes('統編') || jsonData[0]['統編(*)'].includes('ID'))) {
                        jsonData.shift();
                    }

                    const normalizedData = jsonData
                        .map((item, index) => ({
                            ...item,
                            _excelRow: index + 2,
                        }))
                        .filter(item => {
                            return ['統編(*)', '公司名', '標籤(*)'].some(key => {
                                const value = item[key];
                                return value !== null && value !== undefined && String(value).trim() !== '';
                            });
                        });

                    this.validateUploadData(normalizedData);
                    this.parsedData = normalizedData;

                    console.log('解析後的資料:', this.parsedData);
                    
                    if (this.parsedData.length === 0) {
                        this.$message.warning('檔案內容為空或格式不正確');
                    } else {
                        this.$message.success(`成功解析 ${this.parsedData.length} 筆資料`);
                    }
                    
                } catch (error) {
                    console.error('解析 Excel 檔案出錯:', error);
                    this.$message.error('解析檔案時發生錯誤，請確保檔案格式正確');
                }
            };
            
            reader.onerror = () => {
                this.$message.error('讀取檔案時發生錯誤');
            };
            
            reader.readAsArrayBuffer(file);
        },

        validateUploadData(data) {
            const validationErrors = [];

            data.forEach(item => {
                const rowErrors = [];
                const uniComNm = item['統編(*)'] === null || item['統編(*)'] === undefined ? '' : String(item['統編(*)']).trim();
                const tagText = item['標籤(*)'] === null || item['標籤(*)'] === undefined ? '' : String(item['標籤(*)']).trim();

                if (!uniComNm) {
                    rowErrors.push('統編為必填欄位');
                } else if (!/^\d{8}$/.test(uniComNm)) {
                    rowErrors.push('統編格式錯誤，必須為 8 碼數字');
                }

                if (!tagText) {
                    rowErrors.push('標籤為必填欄位');
                } else {
                    const tagValues = tagText
                        .split(/[，,]/)
                        .map(tag => tag.trim())
                        .filter(tag => tag !== '');

                    if (tagValues.length === 0) {
                        rowErrors.push('標籤格式錯誤，請至少輸入一個標籤，可使用逗號分隔多個標籤');
                    }
                }

                if (rowErrors.length > 0) {
                    item.error = rowErrors.join('；');
                    rowErrors.forEach(err => {
                        validationErrors.push({
                            row: `第 ${item._excelRow} 列`,
                            error: err,
                        });
                    });
                } else {
                    item.error = '';
                }
            });

            this.validationErrors = validationErrors;
            this.errorDialogVisible = validationErrors.length > 0;
        },
        
        delay(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        async addHqTagWithRetry(params, maxRetries = 2) {
            for (let attempt = 0; attempt <= maxRetries; attempt++) {
                try {
                    return await this.$api.apitags.add_hq_category_tag(params);
                } catch (error) {
                    const statusCode = error?.response?.status;
                    const errorMessage = String(error?.message || '').toLowerCase();
                    const isSystemBusy = [429, 503, 504].includes(statusCode) ||
                        errorMessage.includes('timeout') ||
                        errorMessage.includes('busy') ||
                        errorMessage.includes('too many');

                    if (attempt < maxRetries && isSystemBusy) {
                        // 系統忙碌時採用遞增等待再重試
                        await this.delay((attempt + 1) * 500);
                        continue;
                    }
                    throw error;
                }
            }
        },

        // 提交解析後的資料
        async submitData() {
            if (this.parsedData.length === 0) {
                this.$message.warning('請先上傳並解析檔案');
                return;
            }

            if (this.hasUploadErrors) {
                this.errorDialogVisible = true;
                this.$message.warning('請先修正檔案資料錯誤後再提交');
                return;
            }

            this.submitting = true;

            const rows = this.parsedData.filter(row => row['統編(*)'] && row['標籤(*)']);
            let successCount = 0;
            let failCount = 0;

            try {
                // 逐筆送出並節流，避免瞬間併發導致系統忙碌
                for (const row of rows) {
                    const tagValues = String(row['標籤(*)'] || '')
                        .split(/[，,]/)
                        .map(tag => tag.trim())
                        .filter(tag => tag !== '');

                    if (tagValues.length === 0) {
                        failCount++;
                        continue;
                    }

                    const params = {
                        "UniComNm": String(row['統編(*)']).trim(),
                        "TagValues": tagValues
                    };
                    console.log('送出標籤參數:', params);
                    try {
                        await this.addHqTagWithRetry(params, 2);
                        successCount++;
                    } catch (error) {
                        failCount++;
                        console.error('新增標籤失敗:', params, error);
                    }

                    await this.delay(200);
                }

                if (failCount === 0) {
                    notify({ type: 'success', title: '成功', message: `標籤資料上傳成功，共 ${successCount} 筆` });
                    
                } else {
                    notify({ type: 'warning', title: '警告', message: `上傳完成，成功 ${successCount} 筆，失敗 ${failCount} 筆` });    
                    
                }

                // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
                const setAudit = {
                    "menu_path": ["分行及標籤管理", "企業標籤管理"],
                    "action_type": "upload",
                    "action_name": "上傳標籤",
                    "details": {
                        "file_name": this.uploadFileName,
                        "parsed_count": this.parsedData.length,
                    }
                }
                const resp = await this.$api.apimgrs.setAuditLog(setAudit);                    

                this.submitting = false;
                this.showuploadTags = false;
                this.resetUploadForm();
                this.getList();
            } catch (error) {
                this.submitting = false;
                handleError(error, '標籤資料上傳失敗');
            }
        },
        
        // 重置表單
        resetUploadForm() {
            this.selectedFile = null;
            this.parsedData = [];
            this.validationErrors = [];
            this.errorDialogVisible = false;
            this.addInfo.memo = '';
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        
        // 舊的方法保留用於參考
        handleSuccess(response, file, fileList) {
            // 文件上傳成功的回調
            console.log(response);
        },

        beforeUpload(file) {
            // 在上傳之前的鉤子，返回 false 可以取消上傳
            console.log(file);
            return true;
        },        

        dashFormat: function(value) {
            
            if( value===null || value?.length!=8) 
                return "";
            else  {                
                return value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6);
            }
        },

        yearFormat: function(value) {
            if( value===null || value.length<4) 
                return "";
            else  {                
                return value.slice(0, 4) + '年';
            }
        },

        async doSearch() {
             if (!this.keyword) {
                 notify({
                     title: '提示',
                     message: '請輸入公司名或統一編號',
                    type: 'warning'
                 });
                 return;
            }
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字
            this.listQuery.Page_Num = 1; // 搜尋時重置頁碼
            this.getList();  
            this.tabsValue = 'main';          
            // ...查詢邏輯...
        },

        async getList() {
            this.$store.dispatch("loadingHandler", true);            
            try {
                const qry = {
                    "Page_Size": this.listQuery.Page_Size,
                    "Page_Num": this.listQuery.Page_Num,
                };
                // 關鍵字如果是統編8碼，則帶入 UniComNm 查詢
                const uniComNmPattern = /^\d{8}$/;
                if( this.keyword && uniComNmPattern.test(this.keyword.trim()) ) {
                    qry.UniComNm = this.keyword.trim();
                }
                else if( this.keyword && this.keyword.trim() !== '' )
                    qry.SearchText = [this.keyword.trim()];

                console.log('查詢參數(' + this.queryType + '):', qry);
                // 修改為第一層搜尋bid_main , 第二層, 以統編來做精準搜尋
                await this.$api.apibidmain.search_bidmain(qry).then((res)=>{                    
                    // 支援後端回傳欄位可能為 res.Data 或 res.data，並在不是陣列時以空陣列代替，避免在 undefined 上呼叫 map
                    const rawData = Array.isArray(res.data) ? res.data : (Array.isArray(res.data) ? res.data : []);
                    console.log('原始查詢結果:', rawData);
                    // this.tableDataMain = rawData.map(item => {
                    //     return {
                    //         ...item,
                    //         has_br_category: item && item.br_category && item.br_category.length > 0,
                    //         has_hq_category: item && item.hq_category && item.hq_category.length > 0,
                    //     };
                    // });
                    this.tableDataMain = []
                    console.log('原始查詢結果:', rawData);
                    rawData.forEach(item => {
                        let dataItem = {
                            ...item,
                            has_br_category: item && item.br_category && item.br_category.length > 0,
                            has_hq_category: item && item.hq_category && item.hq_category.length > 0,
                        };
                        // 如果有分行標籤, 要再過濾相同的使用者, 才能決定是否要不要顯示分行標籤的圖示
                        if( dataItem.has_br_category ) {
                            console.log('檢查分行標籤的使用者:', dataItem.br_category);
                                 item.br_category.forEach(brTag => {
                                    if( brTag.create_user_id === this.$store.getters.userID ) {
                                        dataItem.has_br_category = true;
                                    }
                                    else {
                                        dataItem.has_br_category = false;
                                    }
                                 });
                        }
                        this.tableDataMain.push(dataItem);
                    });


                    // total 若不存在則回退到 rawData 長度，確保數字可用
                    this.totalListsMain = typeof res.total === 'number' ? res.total : rawData.length;
                }, err => {
                    handleError(err, '取得標籤列表失敗');
                });
                
                
            } catch (err) {
                handleError(err, {
                    title: '錯誤',
                    message: '資料載入失敗',
                    type: 'error'
                });
            }
            this.$store.dispatch("loadingHandler", false);
        },        

        async getDetail(UniComNm) {
            this.$store.dispatch("loadingHandler", true);            
            let isSuccess = false;
            try {
                const qry = {
                    "Page_Size": this.listQuery.Page_Size,
                    "Page_Num": this.listQuery.Page_Num,
                    "UniComNm": UniComNm,
                };                
                
                console.log('查詢參數(' + this.queryType + '):', qry);
                if( this.queryType === 'br' ) {
                    // 自訂標籤
                    // 自訂標籤 只要顯示出CreateUserID 
                    qry.CreateUserID = this.$store.getters.userID;                    
                    console.log('帶入 CreateUserID 查詢自訂標籤, 參數:', qry);
                    await this.$api.apitags.query_br_tags(qry).then((res)=>{
                        console.log('取得自訂標籤列表成功:', res);
                        const rawData = Array.isArray(res.data) ? res.data : [];
                        const filteredData = rawData.filter(item => {
                            const key = `${item.UniComNm}_${item.tag_id}`;
                            return !this.pendingDeleteTagKeys[key];
                        });
                        this.tableData = filteredData;
                        this.totalLists = Math.max(0, (res.total || 0) - (rawData.length - filteredData.length));
                    }, err => {
                        handleError(err, '取得標籤列表失敗');
                    });
                }
                else if( this.queryType === 'st' ) {
                    // 標準標籤
                    await this.$api.apitags.query_standard_tags(qry).then((res)=>{
                        console.log('取得標準標籤列表成功:', res);
                        const rawData = Array.isArray(res.data) ? res.data : [];
                        const filteredData = rawData.filter(item => {
                            const key = `${item.UniComNm}_${item.tag_id}`;
                            return !this.pendingDeleteTagKeys[key];
                        });
                        this.tableData = filteredData;
                        this.totalLists = Math.max(0, (res.total || 0) - (rawData.length - filteredData.length));
                    }, err => {
                        handleError(err, '取得標籤列表失敗');
                    });                    
                }
                else if( this.queryType === 'hq' ) {
                    // 總行標籤
                    await this.$api.apitags.query_hq_tags(qry).then((res)=>{
                        console.log('取得總行標籤列表成功:', res);
                        const rawData = Array.isArray(res.data) ? res.data : [];
                        const filteredData = rawData.filter(item => {
                            const key = `${item.UniComNm}_${item.tag_id}`;
                            return !this.pendingDeleteTagKeys[key];
                        });
                        this.tableData = filteredData;
                        this.totalLists = Math.max(0, (res.total || 0) - (rawData.length - filteredData.length));
                    }, err => {
                        handleError(err, '取得標籤列表失敗');
                    });                    
                }
                // 可能因為更換了queryType, 重新取得功能按鈕顯示狀態
                await this.getFunctions();
                isSuccess = true;
                // this.tableData = this.tagsList.slice((this.listQuery.Page_Num - 1) * this.listQuery.Page_Size, this.listQuery.Page_Num * this.listQuery.Page_Size);
                // this.totalLists = this.tagsList.length;
            } catch (err) {
                handleError(err, {
                    title: '錯誤',
                    message: '資料載入失敗',
                    type: 'error'
                });
            }
            this.$store.dispatch("loadingHandler", false);
            return isSuccess;
        },

        formatTagData(data) {
            if (!Array.isArray(data)) return [];
            // 格式化標籤資料以符合表格顯示需求
            return data.map(item => {
                if (!item) return item;
                // 加工投資國家、赴大陸投資、陸資投資 , 增加年度資訊
                if (item.category === "invest_area") {                    
                    return {
                        ...item,
                        name: `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`
                    };
                }
                if (item.category === "is_invest_china") {                    
                    return {
                        ...item,
                        name: `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`
                    };
                } 
                if (item.category === "is_china_fund") {                    
                    return {
                        ...item,
                        name: `${item.event_date ? this.yearFormat(item.event_date) : ''} ${item.name || ''}`
                    };
                }                                
                // 回傳name欄位為 event_date + " 出口 " + name + "級"
                if (item.category === "export_value") {                    
                    return {
                        ...item,
                        name: `${item.event_date ? this.yearFormat(item.event_date) : ''} 出口 ${item.name || ''}級`
                    };
                }
                // 回傳name欄位為 event_date + " 進口 " + name + "級"
                if (item.category === "import_value") {                    
                    return {
                        ...item,
                        name: `${item.event_date ? this.yearFormat(item.event_date) : ''} 進口 ${item.name || ''}級`
                    };
                }      
                // 如果item.name長度超過10字，則截斷並加上省略號
                if (item.name && item.name.length > 10) {
                    return {
                        ...item,
                        name: item.name.slice(0, 10) + '...'
                    };
                }          

                // 未匹配的項目保留原物件，避免回傳 undefined
                return item;
            });
        },

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            if (this.tabsValue === 'detail' && this.addInfo.UniComNm) {
                await this.getDetail(this.addInfo.UniComNm);
                return;
            }
            await this.getList();
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },  
                                 

    },    

    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        // 控制按鈕顯示
        this.getFunctions();
        // 載入熱門標籤
        this.loadHotTags();        
        await this.getList();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
//  * {
//      outline: 1px solid red;
//  }


#tagsMgmtBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;


  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    padding: 0px 5%;
    
    .preview-column {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: flex-start;
        
        h4 {
            margin-bottom: 5px;
            color: #409EFF;
        }
        
        .el-table {
            margin-bottom: 5px;
        }
    }
    
    .full-width {
        width: 100%;
    }
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: center;
            }
        }
    }
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }    
  }


  .searchWrap   {
    display: flex;
    flex-direction: row;    
    justify-content: space-between;    
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: center;
        width: 70%;

        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top:20px; 
            margin-bottom: 20px;
        }
        

    }
    .row3 {
      width:30%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;      
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        margin-top:20px; 
        margin-bottom: 20px;

        label {
          width: 100px;
          white-space: nowrap;
          margin-right: 10px;
          text-align: right;
        }
      }
    }     
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }
}

/* 標籤表單樣式 */
.tag-form {
  padding: 1rem;
}

.form-item {
  margin-bottom: 1.5rem;
  width: 100%;  
}

.form-item label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #606266;
}
</style>